/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import PaginatedListState, { type PaginatedListParams } from 'flarum/common/states/PaginatedListState';
import type User from 'flarum/common/models/User';

export default class HomeReviewsLeaderboardState extends PaginatedListState<User> {
	// `PaginatedListState`'s constructor is protected; re-declared public, forwarding unchanged.
	constructor(...args: [params?: PaginatedListParams, page?: number, pageSize?: number]) {
		super(...args);
	}

	get type(): string {
		return 'of/active_reviewers';
	}
}
